// document.addEventListener("product:variant-change", function (evt) {
//     const skuText = document.getElementById("sku_text");
//     if (skuText) {
//         skuText.textContent = evt.detail.variant.sku;
//     }
// });

// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//   bubbles: true
// }));

// document.addEventListener("cart:item-added", function (evt) {
//     console.log("added to cart");
//     var cartToggle = document.getElementById("cart-drawer-toggle");
//     if (cartToggle) {
//         cartToggle.click();
//     }

// });
// function hideSingleOption() {
//   document.querySelectorAll(".bundly__product_option").forEach((option) => {
//     const radios = option.querySelectorAll(".bundly__variant_radio");

//     if (radios.length === 1) {
//       option.style.display = "none"; // Hide the option
//       option.remove();
//     }
//   });
// }

// // Global event listener to detect clicks on any radio button
// document.addEventListener("click", (event) => {
//   const target = event.target;

//   // Check if the clicked element is a radio button inside .bundly__fixed
//   if (target.matches(".bundly__fixed input.bundly__variant_radio")) {
//     // Delay the hiding function slightly to allow UI updates
//     // setTimeout(hideSingleOption, 100);
//   }
// });

// // Run hide function on initial load
// // hideSingleOption();

// document.addEventListener("DOMContentLoaded", function () {
//   const options = document.querySelectorAll(".bundly__product_option");

//   async function clickValidRadios() {
//     console.log("Auto Click Radio Values");
//     for (const option of options) {
//       const radioButtons = option.querySelectorAll(".bundly__variant_radio");

//       // Find the first non-disabled radio button
//       const validRadio = Array.from(radioButtons).find(
//         (radio) => !radio.classList.contains("bundly__variant_radio_disabled")
//       );

//       if (validRadio) {
//         validRadio.click();
//         await new Promise((resolve) => setTimeout(resolve, 500)); // Wait 500ms before next iteration
//       }
//     }
//   }

//   clickValidRadios();
// //   hideSingleOption();
// });

document.addEventListener("bundlySubmit", (event) => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );

  var cartToggle = document.getElementById("cart-drawer-toggle");
  if (cartToggle) {
    cartToggle.click();
  }
});

// document.addEventListener("DOMContentLoaded", function () {


//     var bundlyMedias = document.querySelector(".bundly__medias");
//     if (!bundlyMedias) return;

//     var originalList = bundlyMedias.querySelector("ul");
//     if (!originalList) return;

//     // Clone the original list
//     var clonedList = originalList.cloneNode(true);
    
//     // Create the thumbnails div and append cloned list
//     var thumbnailsDiv = document.createElement("div");
//     thumbnailsDiv.classList.add("thumbnails");
//     thumbnailsDiv.appendChild(clonedList);

//     // Append thumbnails to bundly__medias
//     bundlyMedias.appendChild(thumbnailsDiv);

//     var flkty = new Flickity(".bundly__medias>ul", {
//         wrapAround: true,
//         pageDots: true,
//         prevNextButtons: true,
//         contain: true,
//         draggable: true,
//         cellAlign: "center",
//         adaptiveHeight: true,
//     });
//      // Initialize Flickity for thumbnails as navigation
//     var flktyNav = new Flickity(".thumbnails > ul", {
//         asNavFor: ".bundly__medias > ul",
//         contain: true,
//         pageDots: false,
//         prevNextButtons: false,
//         cellAlign: "center",
//         draggable: true,
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("Filter-Mobile-availability-4");
  if (checkbox && checkbox.checked == false) {
    checkbox.click();
  }

});


/* BAROCCO SUPABASE SIZE CHARTS — STATIC STOREFRONT EXPORT */
(function () {
  var currentScriptUrl = document.currentScript && document.currentScript.src ? document.currentScript.src : "";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function createElement(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function detectStyle() {
    var main = document.querySelector("main, #main-content");
    var text = main ? main.innerText : "";
    var described = text.match(/Style\s*Number\s*:\s*([A-Z0-9]+)/i);
    if (described) return described[1].toUpperCase();

    var path = window.location.pathname.split("/").filter(Boolean).pop() || "";
    var fromHandle = path.match(/^([a-z]{1,8}\d{2,8})(?:-|$)/i);
    if (fromHandle) return fromHandle[1].toUpperCase();

    var skuCandidates = Array.from(document.querySelectorAll('[id*="sku" i], [class*="sku" i]'));
    for (var i = 0; i < skuCandidates.length; i += 1) {
      var skuMatch = (skuCandidates[i].textContent || "").match(/([A-Z]{1,8}\d{2,8})/i);
      if (skuMatch) return skuMatch[1].toUpperCase();
    }
    return "";
  }

  function sizeRank(label) {
    var normalized = String(label || "").toUpperCase().replace(/\s+/g, "");
    var aliases = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, "2XL": 6, XXXL: 7, "3XL": 7, XXXXL: 8, "4XL": 8, XXXXXL: 9, "5XL": 9, "6XL": 10, "7XL": 11, "8XL": 12 };
    if (Object.prototype.hasOwnProperty.call(aliases, normalized)) return aliases[normalized];
    var numeric = Number(normalized);
    return Number.isFinite(numeric) ? 100 + numeric : 1000;
  }

  function measurementRank(name) {
    var normalized = String(name || "").toLowerCase();
    var priorities = [
      "front length", "back length", "body length", "full length", "pants length", "outseam", "inseam",
      "shoulder", "neck width", "neck drop", "chest", "waist", "hip", "seat", "bottom", "hem",
      "thigh", "knee", "leg opening", "front rise", "back rise", "sleeve", "cuff", "bicep", "armhole"
    ];
    for (var i = 0; i < priorities.length; i += 1) {
      if (normalized.indexOf(priorities[i]) !== -1) return i;
    }
    return 100;
  }

  function buildChartTable(chart) {
    var section = createElement("section", "barocco-size-chart__section");
    section.appendChild(createElement("h3", "barocco-size-chart__chart-title", chart.name || "Size Chart"));
    var units = Array.from(new Set((chart.rows || []).map(function (row) { return String(row[3] || chart.unit || "CM").toUpperCase(); })));
    section.appendChild(createElement("p", "barocco-size-chart__unit", units.length > 1 ? "Units shown per measurement" : "Measurements in " + (units[0] || "CM")));

    var sizes = [];
    var measurements = [];
    var measurementUnits = new Map();
    var values = new Map();

    (chart.rows || []).forEach(function (row) {
      var measurement = row[0];
      var size = row[1];
      var value = row[2];
      if (!measurements.includes(measurement)) measurements.push(measurement);
      if (!sizes.includes(size)) sizes.push(size);
      measurementUnits.set(measurement, String(row[3] || chart.unit || "CM").toUpperCase());
      values.set(measurement + "\u0000" + size, value);
    });

    sizes.sort(function (a, b) {
      var difference = sizeRank(a) - sizeRank(b);
      return difference || String(a).localeCompare(String(b), undefined, { numeric: true });
    });
    measurements.sort(function (a, b) {
      var difference = measurementRank(a) - measurementRank(b);
      return difference || String(a).localeCompare(String(b));
    });

    var scroll = createElement("div", "barocco-size-chart__scroll");
    var table = createElement("table", "barocco-size-chart__table");
    var thead = document.createElement("thead");
    var headerRow = document.createElement("tr");
    headerRow.appendChild(createElement("th", "", "Measurement"));
    sizes.forEach(function (size) {
      headerRow.appendChild(createElement("th", "", size));
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    var tbody = document.createElement("tbody");
    measurements.forEach(function (measurement) {
      var rowNode = document.createElement("tr");
      var measurementLabel = units.length > 1 ? measurement + " (" + (measurementUnits.get(measurement) || "CM") + ")" : measurement;
      rowNode.appendChild(createElement("th", "", measurementLabel));
      sizes.forEach(function (size) {
        var value = values.get(measurement + "\u0000" + size);
        rowNode.appendChild(createElement("td", "", value === undefined || value === null || value === "" ? "—" : value));
      });
      tbody.appendChild(rowNode);
    });
    table.appendChild(tbody);
    scroll.appendChild(table);
    section.appendChild(scroll);
    return section;
  }

  function render(style, chartCodes, data) {
    var primaryVariants = Array.from(document.querySelectorAll("variant-selects")).find(function (node) {
      return !node.classList.contains("variant-selects--sticky");
    });
    var productForm = document.querySelector("product-form");
    var mountAfter = primaryVariants || productForm;
    if (!mountAfter || document.querySelector(".barocco-size-chart-trigger")) return;

    var triggerWrap = createElement("div", "barocco-size-chart-trigger");
    var trigger = createElement("button", "barocco-size-chart-trigger__button", "SIZE CHART");
    trigger.type = "button";
    trigger.setAttribute("aria-haspopup", "dialog");
    trigger.setAttribute("aria-expanded", "false");
    triggerWrap.appendChild(trigger);
    mountAfter.insertAdjacentElement("afterend", triggerWrap);

    var overlay = createElement("div", "barocco-size-chart-modal");
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");

    var dialog = createElement("div", "barocco-size-chart-modal__dialog");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "barocco-size-chart-title");

    var header = createElement("div", "barocco-size-chart-modal__header");
    var headingWrap = createElement("div");
    var eyebrow = createElement("p", "barocco-size-chart-modal__eyebrow", "BAROCCO FIT GUIDE");
    var heading = createElement("h2", "barocco-size-chart-modal__title", "Size Chart — " + style);
    heading.id = "barocco-size-chart-title";
    headingWrap.appendChild(eyebrow);
    headingWrap.appendChild(heading);

    var close = createElement("button", "barocco-size-chart-modal__close", "×");
    close.type = "button";
    close.setAttribute("aria-label", "Close size chart");

    header.appendChild(headingWrap);
    header.appendChild(close);
    dialog.appendChild(header);

    var content = createElement("div", "barocco-size-chart-modal__content");
    chartCodes.forEach(function (code) {
      if (data.charts[code]) content.appendChild(buildChartTable(data.charts[code]));
    });
    dialog.appendChild(content);
    dialog.appendChild(createElement("p", "barocco-size-chart-modal__note", "Garment measurements. For the best fit, compare these measurements with a similar item you own."));
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    function currentTrigger() {
      return document.querySelector(".barocco-size-chart-trigger__button");
    }

    var previousOverflow = "";
    function openModal() {
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
      overlay.hidden = false;
      overlay.setAttribute("aria-hidden", "false");
      var activeTrigger = currentTrigger();
      if (activeTrigger) activeTrigger.setAttribute("aria-expanded", "true");
      close.focus();
    }
    function closeModal() {
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      var activeTrigger = currentTrigger();
      if (activeTrigger) activeTrigger.setAttribute("aria-expanded", "false");
      document.documentElement.style.overflow = previousOverflow;
      if (activeTrigger) activeTrigger.focus();
    }

    document.addEventListener("click", function (event) {
      var clickedTrigger = event.target.closest && event.target.closest(".barocco-size-chart-trigger__button");
      if (clickedTrigger) {
        event.preventDefault();
        openModal();
        return;
      }
      if (event.target === close || event.target === overlay) closeModal();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !overlay.hidden) closeModal();
    });
  }

  function installStyles() {
    if (document.getElementById("barocco-size-chart-styles")) return;
    var style = document.createElement("style");
    style.id = "barocco-size-chart-styles";
    style.textContent = [
      ".barocco-size-chart-trigger{margin:12px 0 18px}",
      ".barocco-size-chart-trigger__button{appearance:none;background:transparent;border:0;border-bottom:1px solid currentColor;color:inherit;cursor:pointer;font:inherit;font-size:13px;font-weight:700;letter-spacing:.09em;padding:2px 0;text-transform:uppercase}",
      ".barocco-size-chart-trigger__button:focus-visible,.barocco-size-chart-modal__close:focus-visible{outline:2px solid #151515;outline-offset:4px}",
      ".barocco-size-chart-modal[hidden]{display:none!important}",
      ".barocco-size-chart-modal{align-items:center;background:rgba(0,0,0,.62);display:flex;inset:0;justify-content:center;padding:24px;position:fixed;z-index:2147483000}",
      ".barocco-size-chart-modal__dialog{background:#fff;color:#151515;max-height:90vh;max-width:1180px;overflow:auto;width:100%;box-shadow:0 24px 80px rgba(0,0,0,.3)}",
      ".barocco-size-chart-modal__header{align-items:flex-start;border-bottom:1px solid #dedede;display:flex;justify-content:space-between;padding:24px 28px 20px;position:sticky;top:0;background:#fff;z-index:5}",
      ".barocco-size-chart-modal__eyebrow{font-size:11px;font-weight:700;letter-spacing:.14em;margin:0 0 6px;text-transform:uppercase}",
      ".barocco-size-chart-modal__title{font-size:26px;line-height:1.15;margin:0;text-transform:uppercase}",
      ".barocco-size-chart-modal__close{appearance:none;background:transparent;border:0;color:#151515;cursor:pointer;font-size:36px;font-weight:300;line-height:1;padding:0 2px}",
      ".barocco-size-chart-modal__content{padding:8px 28px 10px}",
      ".barocco-size-chart__section{margin:24px 0 32px}",
      ".barocco-size-chart__chart-title{font-size:18px;letter-spacing:.04em;margin:0 0 4px;text-transform:uppercase}",
      ".barocco-size-chart__unit{color:#666;font-size:12px;margin:0 0 12px;text-transform:uppercase}",
      ".barocco-size-chart__scroll{border:1px solid #d9d9d9;overflow-x:auto;-webkit-overflow-scrolling:touch}",
      ".barocco-size-chart__table{border-collapse:separate;border-spacing:0;font-size:13px;min-width:700px;width:100%}",
      ".barocco-size-chart__table th,.barocco-size-chart__table td{border-bottom:1px solid #e3e3e3;border-right:1px solid #e3e3e3;padding:11px 12px;text-align:center;white-space:nowrap}",
      ".barocco-size-chart__table thead th{background:#151515;color:#fff;font-weight:700;position:sticky;top:0;z-index:2}",
      ".barocco-size-chart__table th:first-child{left:0;min-width:150px;position:sticky;text-align:left;z-index:3}",
      ".barocco-size-chart__table tbody th{background:#f6f4ef;font-weight:600}",
      ".barocco-size-chart__table tr:last-child th,.barocco-size-chart__table tr:last-child td{border-bottom:0}",
      ".barocco-size-chart__table th:last-child,.barocco-size-chart__table td:last-child{border-right:0}",
      ".barocco-size-chart-modal__note{border-top:1px solid #dedede;color:#666;font-size:12px;margin:0;padding:18px 28px 24px}",
      "@media(max-width:749px){.barocco-size-chart-modal{align-items:flex-end;padding:0}.barocco-size-chart-modal__dialog{max-height:92vh}.barocco-size-chart-modal__header{padding:18px 18px 14px}.barocco-size-chart-modal__title{font-size:21px}.barocco-size-chart-modal__content{padding:4px 16px}.barocco-size-chart__section{margin:20px 0 26px}.barocco-size-chart__table{font-size:12px;min-width:620px}.barocco-size-chart__table th,.barocco-size-chart__table td{padding:9px 10px}.barocco-size-chart-modal__note{padding:16px 18px 20px}}"
    ].join("");
    document.head.appendChild(style);
  }

  ready(function () {
    if (!document.body.classList.contains("template-product")) return;
    var style = detectStyle();
    if (!style || !currentScriptUrl) return;

    var dataUrl = currentScriptUrl.replace(/custom\.js/i, "barocco-size-charts.json");
    fetch(dataUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Size chart data unavailable");
        return response.json();
      })
      .then(function (data) {
        var chartCodes = data.styles && data.styles[style];
        if (!chartCodes || !chartCodes.length) return;
        installStyles();
        render(style, chartCodes, data);
      })
      .catch(function (error) {
        console.warn("[Barocco size chart]", error.message);
      });
  });
})();
/* BAROCCO SIZE CHART DATA VERSION 3 */
